var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infinite-scroller"},[_vm._t("default"),_c('div',{ref:"overlayRef",staticClass:"infinite-scroller__trigger",style:({ height: _vm.offsetY })})],2)}
var staticRenderFns = []

export { render, staticRenderFns }